import { graphql } from 'react-relay';

export const checkTokenAndBankAccount = graphql`
  mutation checkTokenAndBankAccountMutation($bankCode: BankCode!, $account: String!, $code: String!) {
    checkBankAccountByCode(bankCode: $bankCode, account: $account, code: $code) {
      result
      errors {
        code
      }
      taxpayerName
      hometaxBizName
      name
    }
  }
`;
